import { styled } from '@/stitches.config';
import { TagVariant } from './Tag.types';

export const TagStyled = styled('span', {
  borderRadius: '$3',
  px: '$2',
  py: '$1',
  fontWeight: '$bold',
  fontSize: '$normal',
  variants: {
    variant: {
      info: {
        backgroundColor: '$blue800',
        color: '$blue300',
      },
      success: {
        backgroundColor: '$green800',
        color: '$green300',
      },
      error: {
        backgroundColor: '$red800',
        color: '$red300',
      },
    },
  },
  defaultVariants: {
    variant: TagVariant.INFO,
  },
});
